import { render, staticRenderFns } from "./new-connection-business-profile-form.vue?vue&type=template&id=163ebdc6&"
import script from "./new-connection-business-profile-form.vue?vue&type=script&lang=js&"
export * from "./new-connection-business-profile-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports